export const UPDATE_TUTORIAL_STATE = 'UPDATE_TUTORIAL_STATE';
export const SHOW_WELCOME_MODAL = 'SHOW_WELCOME_MODAL';
